  // ✅ Utility: Update header cart count
  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart.item_count;
        const cartIcon = document.querySelector('.cart-link__icon');

        if (cartIcon) {
          let countEl = cartIcon.querySelector('.cart-link__count');

          if (itemCount > 0) {
            if (!countEl) {
              countEl = document.createElement('span');
              countEl.className = 'cart-link__count';
              cartIcon.appendChild(countEl);
            }
            countEl.textContent = itemCount;
          } else if (countEl) {
            countEl.remove();
          }
        }
      });
  }

  // ✅ Booster logic on page load
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('#boost-options');
    if (!container) return;

    const buttons = [...container.querySelectorAll('.boost-button')];

    // Auto-highlight the current booster in cart on load
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const existingBooster = cart.items.find(
          item => item.product_type && item.product_type.toLowerCase() === 'booster'
        );

        if (existingBooster) {
          const activeVariantId = existingBooster.variant_id;
          buttons.forEach(btn => {
            const thisId = parseInt(btn.dataset.variantId, 10);
            if (thisId === activeVariantId) {
              btn.classList.add('is-selected');
            }
          });
        }
      });

    // Handle booster clicks (add, remove, toggle)
    buttons.forEach(btn => {
      btn.addEventListener('click', async () => {
        const selectedVariantId = parseInt(btn.dataset.variantId, 10);
        // Add pop animation
        btn.classList.add("boost-animate");

        btn.addEventListener("animationend", (e) => {
          if (e.animationName === "boostPop") {
            btn.classList.remove("boost-animate");
          }
        }, { once: true });

        try {
          const cart = await fetch('/cart.js').then(r => r.json());

          const existingBooster = cart.items.find(
            item => item.product_type && item.product_type.toLowerCase() === 'booster'
          );

          // ✅ Toggle off if clicked booster is already in cart
          if (existingBooster?.variant_id === selectedVariantId) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: existingBooster.key, quantity: 0 })
            });

            buttons.forEach(b => b.classList.remove('is-selected'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            updateHeaderCartCount();
            return;
          }

          // ✅ Remove existing booster if different one exists
          if (existingBooster) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: existingBooster.key, quantity: 0 })
            });
          }

          // ✅ Add new booster
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
          });

          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          updateHeaderCartCount();

          buttons.forEach(b => b.classList.toggle('is-selected', b === btn));
        } catch (err) {
          console.error('Booster add/remove failed:', err);
        }
      });
    });
  });

  // ✅ Observe cart drawer changes to:
  // – Remove booster if it's the only item
  // – Remove .is-selected highlight
  // – Update header icon
  const observeCartForBoosterChanges = () => {
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const items = cart.items || [];

            const boosters = items.filter(item =>
              item.product_type && item.product_type.toLowerCase() === 'booster'
            );

            const regulars = items.filter(item =>
              !item.product_type || item.product_type.toLowerCase() !== 'booster'
            );

            // ❌ If boosters exist but no regular products, remove all boosters
            if (boosters.length > 0 && regulars.length === 0) {
              const removalPromises = boosters.map(item =>
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: 0 })
                })
              );

              Promise.all(removalPromises).then(() => {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
                updateHeaderCartCount();
              });
            }

            // 🧼 Remove .is-selected if no booster remains
            const hasBooster = boosters.length > 0;
            if (!hasBooster) {
              const container = document.querySelector('#boost-options');
              if (!container) return;

              const buttons = [...container.querySelectorAll('.boost-button')];
              buttons.forEach(btn => btn.classList.remove('is-selected'));
            }

            // ✅ Always update header icon on any cart mutation
            updateHeaderCartCount();
          });
      }, 100);
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const target = cartDrawer.shadowRoot || cartDrawer;
      observer.observe(target, {
        childList: true,
        subtree: true,
      });
    } else {
      setTimeout(observeCartForBoosterChanges, 100);
    }
  };

document.addEventListener('DOMContentLoaded', observeCartForBoosterChanges);

document.addEventListener('DOMContentLoaded', () => {
const toggle = document.getElementById('toggleEntryBoosters');
const content = document.querySelector('.entry-boosters-content');
const wrapper = document.querySelector('.entry-boosters-collapsible');
const icon = document.getElementById('entryBoosterToggleIcon');

  if (toggle && content && wrapper && icon) {
    toggle.addEventListener('click', () => {
      const isOpen = content.classList.toggle('open');
      wrapper.classList.toggle('open');

      // Use a chevron SVG and rotate on toggle
      icon.innerHTML = `
        <svg class="chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      `;

      icon.querySelector('svg').style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
      icon.querySelector('svg').style.transition = 'transform 0.3s ease';
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const infoToggle = document.getElementById('entryBoosterInfoToggle');
  const modal = document.getElementById('entryBoosterModal');
  const closeBtn = document.getElementById('entryBoosterModalClose');

   if (infoToggle && modal && closeBtn) {
      infoToggle.addEventListener('click', (e) => {
        e.stopPropagation(); // 🛑 Prevents collapsible from toggling
        e.preventDefault();
        modal.style.display = 'block';
      });

      closeBtn.addEventListener('click', () => {
          modal.style.display = 'none';
        });

      // Click outside content to close
      modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('entry-booster-modal-backdrop')) {
            modal.style.display = 'none';
          }
      });
  }
});

